import { programmeDetails } from '@Store/slices/programmeDetails';

// eslint-disable-next-line import/prefer-default-export
export const {
  setKeyStakeHoldersTabProgramme,
  setKeyStakeHoldersTabComponent,
  setStatus,
  setStakeholderByProjectSelectedTab,
} = programmeDetails.actions;
